import { render, staticRenderFns } from "./WorkspaceInviteCard.vue?vue&type=template&id=89eaee26&"
import script from "./WorkspaceInviteCard.vue?vue&type=script&lang=js&"
export * from "./WorkspaceInviteCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceInviteCard.vue?vue&type=style&index=0&id=89eaee26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports